var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { AutoAdaptFeature, ComponentIds, RequiredConnectorsSatisfiedValidation, } from "@inter-ikea-core/core";
import { useDexf } from "@inter-ikea-storagetwo/dexf-utils";
import CatalogService from "./services/catalogService";
import { CORE_DOESNT_EXIST } from "./constants/errors";
import SystemsService from "./services/SystemsService";
import { defaultSystems } from "./systems";
import { MetaComponentApplier } from "./ApplyMetaComponentsToEntities";
const defaultSettings = {
    useAutoAdapt: true,
};
export class RangeApi {
    constructor({ core, systemsDefinitionList, catalog, templates, env, appId, components, validations, settings = defaultSettings, componentSerializer, catalogModifiers = [], }) {
        this.viewer = null;
        this.viewerCoreAdapter = null;
        this.systems = {};
        this.systemService = null;
        this.components = {};
        this.validations = {};
        this.componentSerializer = null;
        this.didInit = false;
        this.catalogService = null;
        this.products = [];
        this.fetchRange = () => __awaiter(this, void 0, void 0, function* () {
            const dexf = useDexf(this.appId, this.env);
            const products = yield dexf.getProducts();
            this.products = Object.values(products);
            return products;
        });
        this.registerValidations = () => {
            const { core, validations } = this;
            core.addValidation(new RequiredConnectorsSatisfiedValidation());
            Object.values(validations).forEach((Validation) => {
                core && core.services.validations.register(Validation({ core }));
            });
        };
        this.applyMetaComponentsToEntity = (entity) => {
            this.metaComponentApplier(entity);
        };
        this.core = core;
        this.systemsDefinitionList = Object.assign(Object.assign({}, defaultSystems), systemsDefinitionList);
        this.templates = templates;
        this.catalog = catalog;
        this.env = env;
        this.appId = appId;
        this.components = components || this.components;
        this.validations = validations || this.validations;
        this.settings = Object.assign(Object.assign({}, defaultSettings), settings);
        this.componentSerializer = componentSerializer || this.componentSerializer;
        this.catalogModifiers = [...catalogModifiers];
        this.metaComponentApplier = MetaComponentApplier(this.templates.templates, this.components);
    }
    get Systems() {
        var _a;
        return ((_a = this.systemService) === null || _a === void 0 ? void 0 : _a.Systems) || {};
    }
    setupSystems({ viewer, viewerCoreAdapter }) {
        this.systemService = new SystemsService({
            core: this.core,
            viewer,
            viewerCoreAdapter,
        });
        this.systemService.registerSystems(this.systemsDefinitionList);
    }
    setupCatalog() {
        if (!this.core)
            throw new Error(CORE_DOESNT_EXIST);
        this.catalogService = new CatalogService({
            catalog: this.catalog,
            templates: this.templates,
            core: this.core,
            catalogModifiers: this.catalogModifiers,
        });
        this.catalogService.loadDynamicProductCatalog();
        return this.catalogService.Catalog;
    }
    init(props) {
        var _a;
        if (this.didInit)
            return;
        this.didInit = true;
        if (!((_a = this.catalogService) === null || _a === void 0 ? void 0 : _a.Catalog))
            this.setupCatalog();
        const { viewer, viewerCoreAdapter } = props;
        this.viewer = viewer;
        this.viewerCoreAdapter = viewerCoreAdapter;
        this.setupSystems(props);
        this.registerValidations();
        this.setUpSerialize(this.core);
        this.settings.useAutoAdapt && AutoAdaptFeature.start(this.core.services);
        this.core.services.entityManager.subscribeRemove(ComponentIds.SCENE_RELOADING_COMPONENT_ID, () => {
            var _a;
            (_a = this.systemService) === null || _a === void 0 ? void 0 : _a.loadDisabledOnLoadSystems();
        });
        this.core.services.productManager.subscribeProductCreated(this.applyMetaComponentsToEntity);
    }
    setUpSerialize(core) {
        if (!this.componentSerializer)
            return;
        const componentDeserializerRegistry = core.services.componentDeserializerRegistry;
        componentDeserializerRegistry.register(this.componentSerializer);
    }
}
export var RANGE_IDS;
(function (RANGE_IDS) {
    RANGE_IDS["IVAR"] = "IVAR";
    RANGE_IDS["BOAXEL"] = "BOAXEL";
    RANGE_IDS["BROR"] = "BROR";
    RANGE_IDS["KALLAX"] = "KALLAX";
    RANGE_IDS["ELVARLI"] = "ELVARLI";
    RANGE_IDS["JONAXEL"] = "JONAXEL";
    RANGE_IDS["AURDAL"] = "AURDAL";
})(RANGE_IDS || (RANGE_IDS = {}));
export default RangeApi;
